<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="TeacherNumber" label="人员编号" min-width="100" />
      <el-table-column prop="TeacherName" label="姓名" />
      <el-table-column prop="JobNames" label="职务" />
      <!-- <el-table-column prop="VerificationCode" label="验证码（4位数字）" min-width="150px" /> -->
      <el-table-column prop="PhoneNumber" label="手机号码" />
      <el-table-column prop="CreateTime" label="创建时间">
        <template slot-scope="{row}">
          <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/fa/teacher").default,
      data: [],
      params: {},
      title: "导出 人员信息",
    };
  },
  methods: {
    getData(params) {
      this.params = params;
      this.$refs.dialog.isLoading = true;
      this.api.list(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>